export const HOME_PAGE: string = "home_page";
